
















































import Vue, { PropType } from 'vue';

export default Vue.extend({
  name: 'MStoreSimpleTable',
  props: {
    items: {
      required: true,
      type: Array as PropType<Array<Record<string, any>>>
    },
    fields: {
      required: true,
      type: Array as PropType<Array<{ key: string; description: string }>>
    },
    small: {
      type: Boolean,
      default: true
    },
    primaryKey: {
      required: true,
      type: String
    },
    selectable: {
      type: Boolean,
      default: false
    },
    selectedItems: {
      type: Array,
      required: false
    },
    emptyText: {
      type: String,
      default: 'There are no records to show'
    },
    showActions: {
      type: Boolean,
      default: false
    },
    selectedItem: {
      required: false
    },
    expandedRows: {
      required: false,
      type: Set
    }
  },
  data() {
    return {
      sortBy: null,
      sortDesc: false
    };
  },
  methods: {
    toggleSort(this: any, key: any) {
      if (this.sortBy === key) {
        this.sortDesc = !this.sortDesc;
      } else {
        this.sortBy = key;
        this.sortDesc = !this.sortDesc;
      }
    },
    toggleRow(item: any) {
      this.$emit('toggle-row-expand', item[this.primaryKey]);
    }
  },
  computed: {
    allItemsSelected(this: any) {
      if (!this.items.length) {
        return false;
      }
      const allItemIds = (this.items as Array<Record<string, any>>).map((x) => x[this.primaryKey]);
      const selectedItems = this.selectedItems as any[];
      return allItemIds?.every((item) => selectedItems.includes(item)) ?? false;
    },
    displayedItems(this: any) {
      return this.sortedItems;
    },
    sortedItems(this: any) {
      if (!this.sortBy) {
        return this.items;
      }
      const sortKey = this.sortBy as string;
      return [...this.items].sort((a, b) => {
        const aVal = a[sortKey];
        const bVal = b[sortKey];

        // Check if both values look like dates (ISO or locale date string)
        const isDate = (val: any) => typeof val === 'string' && !isNaN(Date.parse(val));

        if (isDate(aVal) && isDate(bVal)) {
          const aDate = new Date(aVal);
          const bDate = new Date(bVal);
          if (aDate < bDate) {
            return this.sortDesc ? 1 : -1;
          }
          if (aDate > bDate) {
            return this.sortDesc ? -1 : 1;
          }
          return 0;
        }

        // Fallback to string/number comparison
        if (aVal < bVal) {
          return this.sortDesc ? 1 : -1;
        }
        if (aVal > bVal) {
          return this.sortDesc ? -1 : 1;
        }
        return 0;
      });
    }
  }
});
